import { render, staticRenderFns } from "./AdvertsNew.vue?vue&type=template&id=5d7dac3e&"
import script from "./AdvertsNew.vue?vue&type=script&lang=js&"
export * from "./AdvertsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports